import React from "react";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import * as reportApi from "../../api/reportApi";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Button from "@mui/material/Button";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import { toast } from "react-toastify";
import ScrollToTopBtn from "../common/ScrollToTop";
import Tooltip from "@mui/material/Tooltip";
import WarningIcon from "@mui/icons-material/Warning";


class NAVContacts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contacts: [],
      page: 0,
      rowsPerPage: 50,
      sortDirection: "asc",
    };
  }

  async componentDidMount() {
    try {
      this.getYffIncidentContacts();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getYffIncidentContacts = async () => {
    const contacts = await reportApi.getYffIncidentContacts();

    if (contacts) {
      this.setState({ contacts });
    } else {
      this.setState({ contacts: [] });
    }
  };

  handleChangePage = (event, newPage) => {
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({ rowsPerPage: +event.target.value, page: 0 });
  };

  handledownload = async () => {
    const excelfile = await reportApi.getYffIncidentContactsExcel();
    if (excelfile === false) {
      toast.error("Noe gikk feil...");
    }
  };

  handledownloadNav = async () => {
    const excelfile = await reportApi.getNavExtract();
    if (excelfile === false) {
      toast.error("Noe gikk feil...");
    }
  };

  compareBydesc = (key) => {
    return function (a, b) {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    };
  };

  compareByasc = (key) => {
    return function (a, b) {
      if (a[key] < b[key]) return 1;
      if (a[key] > b[key]) return -1;
      return 0;
    };
  };

  sortBy = (key) => {
    let arrayCopy = [...this.state.contacts];
    if (this.state.sortDirection === "asc") {
      arrayCopy.sort(this.compareByasc(key));
      this.setState({ contacts: arrayCopy, sortDirection: "desc" });
    } else {
      arrayCopy.sort(this.compareBydesc(key));
      this.setState({ contacts: arrayCopy, sortDirection: "asc" });
    }
  };

  render() {
    const columns = [
      { id: "", label: "" },
      { id: "companyName", label: "BEDRIFTSNAVN", minWidth: 150 },
      { id: "emailYffDisplay", label: "E-POST", minWidth: 150 },
    ];

    return (
      <React.Fragment>
        <Container maxWidth="lg">
          <main style={{ width: "100%", paddingTop: 80 }}>
            <Paper style={{ width: "100%", padding: "10px 0" }}>
              <div style={{ padding: "5px 15px" }}>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  startIcon={<CloudDownloadIcon />}
                  onClick={this.handledownload}
                >
                  Eierskap og systembrukere (intern)
                </Button>

                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  style={{ marginLeft: 20 }}
                  startIcon={<CloudDownloadIcon />}
                  onClick={this.handledownloadNav}
                >
                  Eksport til NAV
                </Button>
              </div>
              <Paper style={{ margin: "15px" }}>
                <div style={{ marginTop: 10, overflow: "auto" }}>
                  <Table stickyHeader aria-label="sticky table">
                    <TableHead>
                      <TableRow>
                        {columns.map((column, index) => (
                          <TableCell
                            key={index}
                            style={{
                              backgroundColor: "#eeeeee",
                              fontWeight: "bold",
                              fontSize: 16,
                              cursor: "pointer",
                              minWidth: column.minWidth,
                            }}
                            onClick={() => this.sortBy(column.id)}
                          >
                            {column.label}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {this.state.contacts.length > 0 ? (
                        this.state.contacts
                          .slice(
                            this.state.page * this.state.rowsPerPage,
                            this.state.page * this.state.rowsPerPage +
                            this.state.rowsPerPage
                          )
                          .map((contact, index) => (
                            <TableRow key={index} hover>
                              {columns.map((column) => (
                                <TableCell key={column.id} style={{ minWidth: column.minWidth }}>
                                  {column.id === "emailYffDisplay" ? (
                                    contact.emailNavContactYff ? (
                                      contact.emailNavContactYff
                                    ) : (
                                      <>
                                        {contact.emailCaseYff}
                                          <Tooltip title="NAV-kontakt ikke registrert - viser saksbehandlers e-post">
                                          <WarningIcon fontSize="small" style={{ marginLeft: 6, color: "#f57c00" }} />
                                        </Tooltip>
                                      </>
                                    )
                                  ) : (
                                    contact[column.id]
                                  )}

                                </TableCell>
                              ))}
                            </TableRow>
                          ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={columns.length} align="center">
                            Ingen treff
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>

                  <TablePagination
                    rowsPerPageOptions={[10, 50, 100]}
                    component="div"
                    count={this.state.contacts.length || 0}
                    rowsPerPage={this.state.rowsPerPage}
                    page={this.state.page}
                    onPageChange={this.handleChangePage}
                    onRowsPerPageChange={this.handleChangeRowsPerPage}
                  />
                </div>
              </Paper>
            </Paper>
          </main>
        </Container>
        <ScrollToTopBtn />
      </React.Fragment>
    );
  }
}

export default NAVContacts;
